

// import React, { useEffect, useState } from "react";
// import "daterangepicker/daterangepicker.css";
// import "../styles/challengerequests.css";
// import $ from "jquery";
// import moment from "moment";
// import "daterangepicker";

// function DateRangePickerComponent({ setDateRange, initialDateRange }) {
//     const [dateRangeText, setDateRangeText] = useState("");

//     useEffect(() => {
//         const initDateRangePicker = () => {
//             // Always use today's date (start of day → end of day)
//             const start = moment().startOf("day");
//             const end = moment().endOf("day");

//             setDateRangeText(`${start.format("DD/MM/YYYY")} - ${end.format("DD/MM/YYYY")}`);

//             if ($('#dateRangeForUsers').data('daterangepicker')) {
//                 $('#dateRangeForUsers').data('daterangepicker').remove();
//             }

//             $('#dateRangeForUsers').daterangepicker(
//                 {
//                     startDate: start,
//                     endDate: end,
//                     autoApply: false,
//                     showDropdowns: true,
//                     opens: "right",
//                     linkedCalendars: false,
//                     alwaysShowCalendars: true,
//                     locale: {
//                         format: "DD/MM/YYYY",
//                         separator: " - ",
//                         cancelLabel: "Clear",
//                         applyLabel: "Apply",
//                         fromLabel: "From",
//                         toLabel: "To",
//                         customRangeLabel: "Custom",
//                         weekLabel: "W",
//                         daysOfWeek: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
//                         monthNames: [
//                             "January", "February", "March", "April", "May", "June",
//                             "July", "August", "September", "October", "November", "December"
//                         ],
//                         firstDay: 0,
//                     },
//                     minDate: moment().subtract(1, "years"),
//                     maxDate: moment().add(1, "years"),
//                 },
//                 (pickedStart, pickedEnd) => {
//                     setDateRange({
//                         startDate: pickedStart.format("YYYY-MM-DD"),
//                         endDate: pickedEnd.format("YYYY-MM-DD")
//                     });
//                     setDateRangeText(`${pickedStart.format("DD/MM/YYYY")} - ${pickedEnd.format("DD/MM/YYYY")}`);
//                 }
//             );

//             $('#dateRangeForUsers').on("cancel.daterangepicker", function () {
//                 const todayStart = moment().startOf("day");
//                 const todayEnd = moment().endOf("day");
//                 setDateRange({
//                     startDate: todayStart.format("YYYY-MM-DD"),
//                     endDate: todayEnd.format("YYYY-MM-DD")
//                 });
//                 setDateRangeText(`${todayStart.format("DD/MM/YYYY")} - ${todayEnd.format("DD/MM/YYYY")}`);
//             });
//         };

//         initDateRangePicker();

//         return () => {
//             if ($('#dateRangeForUsers').data('daterangepicker')) {
//                 $('#dateRangeForUsers').data('daterangepicker').remove();
//             }
//         };
//     }, []);

//     return (
//         <div className="common-field common-field-date mt-2">
//             <input
//                 type="text"
//                 className="form-control float-right"
//                 id="dateRangeForUsers"
//                 placeholder="Select Date Range"
//                 value={dateRangeText}
//                 readOnly
//             />
//             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 5.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
//             </svg>
//         </div>
//     );
// }

// export default DateRangePickerComponent;
import React, { useEffect, useState } from "react";
import "daterangepicker/daterangepicker.css";
import "../styles/challengerequests.css";
import $ from "jquery";
import moment from "moment";
import "daterangepicker";

// The component now accepts an initialDateRange prop
function DateRangePickerComponent({ setDateRange, initialDateRange }) {
    const [dateRangeText, setDateRangeText] = useState("");

    useEffect(() => {
        const initDateRangePicker = () => {
            // Use the initialDateRange prop or default to today
            let start, end;
            if (initialDateRange?.startDate && initialDateRange?.endDate) {
                start = moment(initialDateRange.startDate).startOf("day");
                end = moment(initialDateRange.endDate).endOf("day");
            } else {
                start = moment().startOf("day");
                end = moment().endOf("day");
            }

            setDateRangeText(`${start.format("DD/MM/YYYY")} - ${end.format("DD/MM/YYYY")}`);

            if ($('#dateRangeForUsers').data('daterangepicker')) {
                $('#dateRangeForUsers').data('daterangepicker').remove();
            }

            $('#dateRangeForUsers').daterangepicker(
                {
                    startDate: start,
                    endDate: end,
                    autoApply: false,
                    showDropdowns: true,
                    opens: "right",
                    linkedCalendars: false,
                    alwaysShowCalendars: true,
                    locale: {
                        format: "DD/MM/YYYY",
                        separator: " - ",
                        cancelLabel: "Clear",
                        applyLabel: "Apply",
                        fromLabel: "From",
                        toLabel: "To",
                        customRangeLabel: "Custom",
                        weekLabel: "W",
                        daysOfWeek: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                        monthNames: [
                            "January", "February", "March", "April", "May", "June",
                            "July", "August", "September", "October", "November", "December"
                        ],
                        firstDay: 0,
                    },
                    minDate: moment().subtract(1, "years"),
                    maxDate: moment().add(1, "years"),
                },
                (pickedStart, pickedEnd) => {
                    setDateRange({
                        startDate: pickedStart,
                        endDate: pickedEnd
                    });
                    setDateRangeText(`${pickedStart.format("DD/MM/YYYY")} - ${pickedEnd.format("DD/MM/YYYY")}`);
                }
            );

            $('#dateRangeForUsers').on("cancel.daterangepicker", function () {
                const todayStart = moment().startOf("day");
                const todayEnd = moment().endOf("day");
                setDateRange({
                    startDate: todayStart,
                    endDate: todayEnd
                });
                setDateRangeText(`${todayStart.format("DD/MM/YYYY")} - ${todayEnd.format("DD/MM/YYYY")}`);
            });
        };

        // Re-initialize the picker whenever initialDateRange changes
        initDateRangePicker();

        return () => {
            if ($('#dateRangeForUsers').data('daterangepicker')) {
                $('#dateRangeForUsers').data('daterangepicker').remove();
            }
        };
    }, [initialDateRange, setDateRange]); // Dependency on initialDateRange

    return (
        <div className="common-field common-field-date mt-2">
            <input
                type="text"
                className="form-control float-right"
                id="dateRangeForUsers"
                placeholder="Select Date Range"
                value={dateRangeText}
                readOnly
            />

            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 5.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
            </svg>
        </div>
    );
}

export default DateRangePickerComponent;